/* ZG Reveal — load stagger + scroll reveals (vanilla, no dependencies).
   Pairs with assets/zg-reveal.css; hidden states are CSS-gated on html.js,
   so this file only ever ADDS visibility. */
(function () {
  'use strict';
  var html = document.documentElement;

  /* No observer support or reduced motion: hand visibility back to CSS
     immediately (the media query also guards, this skips the timers). */
  if (!('IntersectionObserver' in window) ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    html.classList.add('zg-reveal-off');
    return;
  }

  /* ── 1. Page-load stagger: first element ~150ms after the loader leaves,
        +120ms per subsequent element (document order).
        Counted on the storefront 28/08: the theme holds exactly ONE
        [data-zg-load] node — .seh-proof in lux-scroll-expand-hero, behind the
        show_proof setting, which is off on the home. Home, product page,
        collection and a producer page all render zero. This loop reveals
        nothing today; the numbers below have never staggered anything. Do not
        tune them for a cascade that has no elements. ── */
  function loadSequence() {
    /* document order by default; data-zg-load-order bumps an element later
       (the hero media sits before the copy in the DOM but reveals after it) */
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-zg-load]'));
    els.sort(function (a, b) {
      return (+a.getAttribute('data-zg-load-order') || 0) - (+b.getAttribute('data-zg-load-order') || 0);
    });
    for (var i = 0; i < els.length; i++) {
      (function (el, i) {
        setTimeout(function () { reveal(el); }, 150 + i * 120);
      })(els[i], i);
    }
  }

  /* Late lazy-loaded imagery still gets the brightness ramp instead of
     popping in: hold the reveal until the img has pixels. */
  function reveal(el) {
    if (el.hasAttribute('data-zg-media-ramp') && el.tagName === 'IMG' && !el.complete) {
      el.addEventListener('load', function () { el.classList.add('zg-revealed'); }, { once: true });
      return;
    }
    el.classList.add('zg-revealed');
  }

  /* The brand loader (theme.liquid #loader) covers the first pageview of a
     session: a 1.1s zg-loader-intro animation, removed on animationend with a
     1250ms fail-safe (theme.liquid), skipped from the second pageview via
     sessionStorage and skipped entirely under prefers-reduced-motion.
     Starting the stagger at DOMContentLoaded would play it invisibly behind
     the overlay, so wait for the loader to leave the DOM — with a safety set
     just past the loader's own fail-safe, so a stuck loader cannot hold
     content hostage.
     1600ms and not 6000: the number it replaces was measured against a loader
     that lasted 3.5s and has not existed for some time. A safety four times
     longer than the thing it guards protects nothing. */
  var started = false;
  function startOnce() {
    if (started) return;
    started = true;
    loadSequence();
  }
  function startWhenLoaderDone() {
    if (!document.getElementById('loader')) { startOnce(); return; }
    var iv = setInterval(function () {
      if (!document.getElementById('loader')) { clearInterval(iv); startOnce(); }
    }, 120);
    setTimeout(function () { clearInterval(iv); startOnce(); }, 1600);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startWhenLoaderDone);
  } else {
    startWhenLoaderDone();
  }

  /* ── 2. One shared observer for scroll reveals; reveal once, unobserve. ── */
  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (!entries[i].isIntersecting) continue;
      var el = entries[i].target;
      if (el.hasAttribute('data-zg-reveal-stagger')) {
        for (var c = 0; c < el.children.length; c++) {
          el.children[c].style.transitionDelay = (c * 100) + 'ms';
        }
      }
      reveal(el);
      io.unobserve(el);
    }
  }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });

  var targets = document.querySelectorAll('[data-zg-reveal], [data-zg-reveal-stagger], [data-zg-media-ramp]:not([data-zg-load])');
  for (var t = 0; t < targets.length; t++) io.observe(targets[t]);

  /* Theme editor: a reloaded section re-renders in its hidden state and the
     one-shot observers above no longer know it — reveal it instantly (no
     re-animation churn while merchandising). */
  document.addEventListener('shopify:section:load', function (e) {
    var els = (e.target || document).querySelectorAll('[data-zg-load], [data-zg-reveal], [data-zg-reveal-stagger], [data-zg-media-ramp]');
    for (var i = 0; i < els.length; i++) reveal(els[i]);
  });
})();
